// extracted by mini-css-extract-plugin
module.exports = {"sideMenuButton":"SideMenuButton_sideMenuButton__2HDtM","menuButton":"SideMenuButton_menuButton__3Y7BA"};